// Concept M: horizontally scrollable genre rows on the start page ([data-genre-row], template-parts/genre-row.php).
// Desktop: prev/next buttons scroll by ~one viewport of cards and are disabled at the ends. Touch: native swipe + scroll-snap.
// Keyboard: the track is a focusable region (arrow keys scroll natively); Home/End jump to the first/last card.
import { qsa } from './dom.js';

export function initGenreRows() {
  qsa('[data-genre-row]').forEach((row) => {
    const track = row.querySelector('[data-row-track]');
    const prev = row.querySelector('[data-row-prev]');
    const next = row.querySelector('[data-row-next]');
    if (!track) return;
    const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const update = () => {
      const max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
    };
    const step = (dir) => {
      const card = track.querySelector('li');
      const gap = parseFloat(getComputedStyle(track).columnGap || '16') || 16;
      const w = card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
      const per = Math.max(1, Math.floor(track.clientWidth / w));
      track.scrollBy({ left: dir * per * w, behavior: reduce ? 'auto' : 'smooth' });
    };
    prev && prev.addEventListener('click', () => step(-1));
    next && next.addEventListener('click', () => step(1));
    track.addEventListener('scroll', () => window.requestAnimationFrame(update), { passive: true });
    track.addEventListener('keydown', (e) => {
      if (e.target !== track) return;
      if (e.key === 'Home') { e.preventDefault(); track.scrollTo({ left: 0 }); }
      if (e.key === 'End') { e.preventDefault(); track.scrollTo({ left: track.scrollWidth }); }
    });
    // Tabbing to a card that is partly hidden: bring it fully into view.
    track.addEventListener('focusin', (e) => {
      const li = e.target.closest('li');
      if (li && e.target !== track) li.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: reduce ? 'auto' : 'smooth' });
    });
    window.addEventListener('resize', update, { passive: true });
    update();
  });
}
